<script>
    import {CONTACT} from "../lib/js/constants.js";
    import {rawPhone} from "../lib/js/utils.js";
    import Icon from "../lib/components/icons/Icon.svelte";
</script>
<div class="d-flex align-items-center justify-content-center" style="height: 100vh;">
    <div>
        <div class="logo mx-auto mb-4">
            <img src="/app/assets/images/logo.png" class="img-fluid" alt="regent mile logo">
        </div>
        <div class="text-center mx-auto">
            <div class="contact-links mb-2">
                <a href="mailto:{CONTACT.EMAIL}" class="contact-item">
                    <span class="info">email</span>
                    <span><Icon name="envelope" size="30"/></span>
                </a>
                <a href="tel:{rawPhone(CONTACT.PHONE)}" class="contact-item">
                    <span class="info">phone</span>
                    <span><Icon name="phone" size="30"/></span>
                </a>
                <a href="https://wa.me/{rawPhone(CONTACT.WHATSAPP)}" class="contact-item" target="_blank"
                   rel="noopener noreferrer">
                    <span class="info">whatsapp</span>
                    <span><Icon name="whatsapp" size="30"/></span>
                </a>
                <a href="viber://chat?number={encodeURIComponent(rawPhone(CONTACT.VIBER))}" class="contact-item">
                    <span class="info">viber</span>
                    <span><Icon name="viber" size="30"/></span>
                </a>
            </div>
        </div>
    </div>
</div>

<style>
    .logo {
        width: 250px;
    }

    .contact-links {
        display: flex;
        gap: 20px;
        width: max-content;
        margin: auto;
    }

    .contact-links .contact-item {
        width: 48px;
        height: 48px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        background: #fff;
        color: #151515;
        border: 1px solid #b3b3b3;
    }

    .contact-links .contact-item:hover {
        color: #fff;
        background: #01b3a7;
        border-color: #01b3a7;
    }

    .contact-links .contact-item .info {
        display: block;
        font-size: 8px;
        line-height: 1;
    }
</style>